/**
 * A person's colour as drawn (O10 of the conformance check). Colours are stored as hex
 * (`USER_COLORS`); the first of them is the prototype's `--peer`, which the dark theme lightens
 * (`#c2338b` → `#ff7ac6`, tokens.css). Drawing that one through the token follows the theme; the
 * prototype keeps every other student colour as it is in both themes, and so does this. Stored
 * data is never changed.
 */
const THEMED: Readonly<Record<string, string>> = {
  '#c2338b': 'var(--peer)',
};

export function themeColor(color: string): string;
export function themeColor(color: string | null | undefined): string | undefined;
export function themeColor(color: string | null | undefined): string | undefined {
  if (!color) return color ?? undefined;
  return THEMED[color.trim().toLowerCase()] ?? color;
}
